<template>
    <b-row class="h-100">
        <b-col cols="3" class="bg-white">
            <div class="mt-4">
                <h2>My API Credentials</h2>
                <p>Review and edit your API credentials.</p>

                <b-btn
                        variant="primary"
                        :to="{name: 'machine-apps-create'}"
                >
                    <font-awesome-icon
                            class="mr-2"
                            :icon="['fal', 'plus']"
                    ></font-awesome-icon>
                    Create new API credentials

                </b-btn>
                <hr class="my-5">
            </div>
        </b-col>
        <b-col class="bg-grey">
            <div class="mt-5">
            <b-row>
                <b-col cols="4"
                       class="mb-3"
                >
                    <b-card
                            bg-variant="white"
                            title="Create new API credentials"
                            @click="$router.push({name: 'machine-apps-create'})"
                            class="text-capitalize cursor-pointer shadow-sm h-100 border-secondary border-2 border-dashed"
                    >
                        <div class="d-flex justify-content-end">
                            <b-btn pill variant="primary">
                                <font-awesome-icon
                                        :icon="['fal', 'plus']"
                                ></font-awesome-icon>
                            </b-btn>
                        </div>
                    </b-card>
                </b-col>
                <b-col cols="4"
                       v-for="app in list"
                       :key="app.applicationId"
                       class="mb-3"
                >
                    <b-card
                            bg-variant="white"
                            :title="app.name"
                            @click="$router.push({name: 'machine-apps-view', params: { id: app.applicationId } })"
                            class="text-capitalize border-secondary cursor-pointer shadow-sm h-100 "

                    >
                        <small>{{ app.description }}</small>

                    </b-card>
                </b-col>
            </b-row>
            </div>
            <vue-element-loading :active="loading"></vue-element-loading>
        </b-col>
    </b-row>
</template>

<script>
import MachineApplications from '@/services/Apps/MachineApplications';

export default {
  name: 'Index-App',
  data() {
    return {
      list: [],
      loading: false,
      hoverClass: '',
    };
  },
  async mounted() {
    await this.fetchList();
  },
  methods: {
    async fetchList() {
      this.loading = true;

      try {
        const { data } = await MachineApplications.list();
        this.list = data.data;
      } catch (e) {
        this.$notify({
          duration: 5000,
          title: 'Unable to fetch your apps',
          text: 'Unable to get your apps at this time. Please try again later.',
          type: 'error',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
